import { BeneficiarioModel } from "../models/beneficiarioModel";
import { columns } from "../../../dtos/columns";
import { format } from "rut.js";

export function useColumnsResultsExcel() {

    const COLUMNSEXCEL: columns<BeneficiarioModel>[] = [
        {
            name: 'Nombre Beneficiario',
            selector: (row: BeneficiarioModel) => row.nombreBeneficiario,
            sortable: true,
            sortField: 'nombreBeneficiario',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT Beneficiario',
            selector: (row: BeneficiarioModel) => format(row.rutBeneficiario!),
            sortable: true,
            sortField: 'rutBeneficiario',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Observaciones',
            selector: (row: BeneficiarioModel) => {
                let excelRow: string = "";
                for(const rowIndex of row.erroresLiquidacion){
                    excelRow += rowIndex.mensaje + ";";
                }
                return excelRow;
            },
            sortable: true,
            sortField: 'erroresLiquidacion',
            wrap: true,
            alling: 'left',
            export: true,
        }
    ]

    return { COLUMNSEXCEL };
}